/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReportsKpiFilters/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PeriodType from './PeriodType/index'
import PeriodUnit from './PeriodUnit/index'
import PeriodYear from './PeriodYear/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ReportsKpiFilters({
  children,
  viewPath = "/DesignSystem/ReportsKpiFilters"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="ReportsKpiFilters.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZwWGLr': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<PeriodType
  viewPath={`${viewPath}/PeriodType`}
/>
<PeriodUnit
  viewPath={`${viewPath}/PeriodUnit`}
/>
<PeriodYear
  viewPath={`${viewPath}/PeriodYear`}
/>
</div>
{children}
</React.Fragment>)
}